import { RouteObject } from "react-router-dom";
import { ProjecType } from "../features/projects/pages/project-type.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";

export const projectsRoutes: RouteObject[] = [
  {
    path: "/projects/create/select-type",
    element: (
      <WithAuth>
        <ProjecType />
      </WithAuth>
    ),
  },
];
